import { useTheme } from "@mui/styles";
import Box from "@mui/material/Box";

export default function MuiMarkupWrap({
  children,
  customMargin,
  customH2Size,
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        margin: customMargin ? customMargin : "0% 20% 0 20%",
        position: "relative",
        display: "flex",
        width: "auto",
        fontSize: theme.spacing(2),

        "& h2": {
          tabIndex: 0,
          color: theme.palette.primary.main,
          fontSize: customH2Size ? customH2Size : "auto",
          "&:focus": {
            outline: "none",
            borderRadius: theme.spacing(0.5),
            boxShadow: `0 0 0 ${theme.spacing(0.5)} ${
              theme.palette.success.main
            }`,
          },
          [theme.breakpoints.down("md")]: {
            margin: theme.spacing(1),
          },
        },

        [theme.breakpoints.down("md")]: {
          fontSize: theme.spacing(2),
          margin: "0% 5%",
          display: "flex",
          flexDirection: "column",

          "& div": {
            "& table": {
              fontSize: "12px",
              width: "100%",
              overflowX: "scroll",
            },
          },
        },

        "& table,th,td": {
          border: `1px solid ${theme.palette.primary.main}`,
        },
        "& table th, table td": {
          padding: "10px",
        },
        "& table": {
          fontSize: "1em",
          fontWeight: "550",
          "& h2": {
            fontSize: `1em !important`,
            fontWeight: `550 !important`,
          },
          "& a": {
            color: theme.palette.highContrastLink.main,
            textDecoration: "underline",
            "&:hover": {
              color: theme.palette.highContrastLink.dark,
            },
          },
        },
        "& thead": {
          backgroundColor: theme.palette.primary.main,
          color: "white !important",
        },

        "& img": {
          maxWidth: "94%",
        },

        "& > iframe": {
          maxWidth: "94%",
        },
      }}
    >
      {children}
    </Box>
  );
}
